import React from 'react';

const InviteFriends = props => {
  const { width, colors } = props;
  const { primary } = colors;
  const h = 744;
  const w = 1429;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      viewBox="0 0 1429 744"
      {...props}>
      <defs>
        <clipPath id="prefix__b">
          <rect
            data-name="Rectangle 1146"
            width={255}
            height={255}
            rx={26}
            fill="#5336ff"
          />
        </clipPath>
        <clipPath id="prefix__c">
          <path
            data-name="Rectangle 1134"
            fill="#fff"
            stroke="#707070"
            strokeWidth={0.274}
            d="M0 0h322.51v750.15H0z"
          />
        </clipPath>
        <clipPath id="prefix__d">
          <path
            data-name="Rectangle 9"
            fill="#f5ba3d"
            stroke="#707070"
            strokeWidth={0.293}
            d="M0 0h15.406v16.317H0z"
          />
        </clipPath>
        <clipPath id="prefix__e">
          <rect
            data-name="Rectangle 1146"
            width={255}
            height={255}
            rx={26}
            transform="translate(1806 2096)"
            fill="#5336ff"
          />
        </clipPath>
        <clipPath id="prefix__f">
          <path
            data-name="Rectangle 1134"
            fill="#fff"
            stroke="#707070"
            strokeWidth={0.274}
            d="M0 0h322.51v750.15H0z"
          />
        </clipPath>
        <clipPath id="prefix__g">
          <rect
            data-name="Rectangle 1145"
            width={255}
            height={255}
            rx={26}
            fill="#fff"
          />
        </clipPath>
        <clipPath id="prefix__h">
          <path
            data-name="Rectangle 1139"
            fill="#fff"
            stroke="#707070"
            strokeWidth={0.27}
            d="M0 0h394.021v751.029H0z"
          />
        </clipPath>
        <clipPath id="prefix__i">
          <path
            data-name="Rectangle 906"
            fill="#fff"
            stroke="#707070"
            strokeWidth={0.828}
            d="M0 0h368.037v751.43H0z"
          />
        </clipPath>
        <clipPath id="prefix__j">
          <rect
            data-name="Rectangle 1143"
            width={255}
            height={255}
            rx={26}
            transform="translate(241 2283)"
            fill="#fff"
            stroke="#707070"
          />
        </clipPath>
        <clipPath id="prefix__k">
          <path
            data-name="Rectangle 1139"
            fill="#fff"
            stroke="#707070"
            strokeWidth={0.27}
            d="M0 0h394.021v751.028H0z"
          />
        </clipPath>
        <clipPath id="prefix__l">
          <path
            data-name="Rectangle 906"
            fill="#fff"
            stroke="#707070"
            strokeWidth={0.828}
            d="M0 0h368.037v751.429H0z"
          />
        </clipPath>
        <clipPath id="prefix__a">
          <path d="M0 0h1429v744H0z" />
        </clipPath>
      </defs>
      <g clipPath="url(#prefix__a)">
        <path
          data-name="Path 1763"
          d="M263.655 51.998h203a26 26 0 0126 26v203a26 26 0 01-26 26h-203a26 26 0 01-26-26v-203a26 26 0 0126-26z"
          fill="#98f"
        />
        <path
          data-name="Subtraction 4"
          d="M238.131 276.331V77a25.978 25.978 0 0126-26h203a25.937 25.937 0 0119.523 8.829L238.131 276.331z"
          fill="#fff"
          opacity={0.09}
        />
        <g
          data-name="Mask Group 456"
          transform="translate(230.655 51.998)"
          clipPath="url(#prefix__b)">
          <g
            data-name="Mask Group 452"
            transform="translate(7.213 -63)"
            clipPath="url(#prefix__c)">
            <g data-name="Group 1241">
              <g data-name="Group 1239">
                <path
                  data-name="Path 367"
                  d="M210.786 263.94c-6.495-47.69-36.26-86.842-31.294-117.385s3.857-46.436-15.507-62.897-44.57-13.792-69.178 8.804S84.79 162.103 54.61 201.739s-27.434 98.545 11.965 120.066 172.288 35.545 138.906 15.514 11.802-25.689 5.304-73.379z"
                  fill="#5a2c1f"
                />
                <path
                  data-name="Path 1593"
                  d="M205.733 304.168l-62.699-54.437s1.025-46.72 9.235-56.832 15.774 12.407 15.774 12.407l47.46 72.33z"
                  fill="#cc8a59"
                  opacity={0.998}
                />
                <g data-name="Group 1149">
                  <g data-name="Group 1148">
                    <path
                      data-name="Rectangle 2"
                      fill="#e3a976"
                      d="M115.349 138.374h31.649v49.393h-31.649z"
                    />
                    <path
                      data-name="Intersection 2"
                      d="M136.684 181.927a46.586 46.586 0 01-21.335-22.244v-11.018h31.649v36.069a28.136 28.136 0 01-10.314-2.807z"
                      fill="#cc8a59"
                    />
                    <path
                      data-name="Path 4"
                      d="M102.198 136.781c-8.746-21.61 4.431-43.713 12.341-47.918s25.415-10.97 39.144-3.352 23.889 16.718 20.787 39.35-19.876 52.336-32.837 51.784-30.688-18.245-39.435-39.864z"
                      fill="#e3a976"
                    />
                    <path
                      data-name="Intersection 1"
                      d="M148.055 83.249a26.372 26.372 0 015.632 2.314c13.727 7.615 23.888 16.714 20.787 39.338-2.603 19.015-14.876 43.029-26.419 49.874z"
                      fill="#cc8a59"
                    />
                    <path
                      data-name="Path 6"
                      d="M147.337 131.407l6.057 16.052-9.531 7.532z"
                      fill="#e3a976"
                    />
                    <path
                      data-name="Path 7"
                      d="M136.272 133.163l-.681-.766a10.984 10.984 0 00-7.089-3.743 51.7 51.7 0 00-10.491 1.688"
                      fill="none"
                      stroke="#360e0e"
                      strokeWidth={1.5}
                    />
                    <path
                      data-name="Path 8"
                      d="M151.936 133.163s3.165-4.509 6.906-4.509a41.294 41.294 0 019.32 1.688"
                      fill="none"
                      stroke="#360e0e"
                      strokeWidth={1.5}
                    />
                    <path
                      data-name="Path 9"
                      d="M128.606 129.458c1.422-.479 4.286-.122 4.852 1.492a2.793 2.793 0 01-.039 2.249 2.9 2.9 0 01-1.688 1.528c-1.602.566-4.101.128-4.671-1.482a2.876 2.876 0 011.546-3.787z"
                      fill="#360e0e"
                    />
                    <path
                      data-name="Path 1638"
                      d="M160.255 129.458c1.422-.479 4.286-.122 4.852 1.492a2.793 2.793 0 01-.039 2.249 2.9 2.9 0 01-1.688 1.528c-1.602.566-4.101.128-4.671-1.482a2.876 2.876 0 011.546-3.787z"
                      fill="#360e0e"
                    />
                    <path
                      data-name="Path 11"
                      d="M139.417 123.071l-1.391 3.027a31.761 31.761 0 00-11.836-4.807 40.534 40.534 0 00-13.752.882 26.185 26.185 0 0112.466-3.069 43.544 43.544 0 0114.513 3.967z"
                      fill="#5a2c1f"
                    />
                    <path
                      data-name="Path 12"
                      d="M150.467 123.075l1.125 3.044a21.1 21.1 0 019.035-4.616 24.671 24.671 0 0110.603 1.098 17.443 17.443 0 00-9.652-3.261 27.109 27.109 0 00-11.111 3.735z"
                      fill="#5a2c1f"
                    />
                    <path
                      data-name="Path 13"
                      d="M147.955 157.309c-.361.023-1.494.043-2.515 0-1.705-.031-1.517.115-4.538 0s-7.545-.461-7.545-.461 5.789 7.874 12.083 8.555 9.262-7.063 9.262-7.063a24.533 24.533 0 00-6.747-1.03z"
                      fill="#be4851"
                    />
                    <path
                      d="M91.566 193.858l22.169-6.555h34.312s11.791 1.488 17.512 6.555c8.475 7.493 11.463 15.913 22.653 33.9 17.788 28.607-2.812 34.244-7.385 64.882s0 64.3 0 64.3H80.546l30.892-70.976s-24.217-45.48-24.217-68.5 4.345-23.606 4.345-23.606z"
                      fill="#5d48f8"
                    />
                    <path
                      data-name="Path 24"
                      d="M115.563 182.634v3.685l-10.145 2.789s28.758 41.918 54.35 41.953c26.378-5.664.884-38.772-2.6-41.953-.555-.508-10.073-2.041-10.073-2.041z"
                      fill="#e3a976"
                    />
                    <path
                      data-name="Path 25"
                      d="M83.032 320.919l18.842-79.09s-13.86-31.303-24.154-30.643-11.554 32.808-11.554 32.808l-8.703 82.922z"
                      fill="#e3a976"
                      opacity={0.998}
                    />
                    <path
                      data-name="Path 29"
                      d="M93.729 193.911s-8.163-1.08-14.865 7.531-14.424 30-9.583 42.62 17.734 6.05 28.949 7.871c.641.108 2.84 2.46 3.61 2.338 9.627-1.528 3.735-25.031 3.7-26.472s-3.606-15.633-5.774-23.507"
                      fill="#e3a976"
                    />
                  </g>
                  <path
                    data-name="Path 1590"
                    d="M164.754 99.388s-27.224-.642-42.043 6.733c-8.194 4.078-9.4 15.847-10.304 23.682s-8.756 39.277-8.756 39.277v-8.274c-8.38-5.121-4.457-13.872-7.48-22.928-4.469-14.623-12.492-31.305 1.457-45.75 12.76-10.024 11.75-1.597 18.3-4.594 8.236-3.778 13.73-7.146 23.312-6.916 16.051.386 25.514 18.77 25.514 18.77z"
                    fill="#5a2c1f"
                  />
                  <path
                    data-name="Path 1591"
                    d="M116.232 98.895l20.935 13.862s10.497 10.22 36.401 13.653c8.521 1.13-1.94-26.867-1.94-26.867s-21.53-31.245-43.102-24.409-12.294 23.761-12.294 23.761z"
                    fill="#5a2c1f"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
        <path
          data-name="Path 1594"
          d="M445.874 294.328c-6.899-3.718-17.05-18.69-3.546-47.126s28.698-63.644 28.698-63.644l11.601 2.597s-5.936 40.955-14.36 75.7-15.508 36.2-22.393 32.473z"
          fill="#cc8a59"
        />
        <path
          data-name="Path 1595"
          d="M471.001 183.645s-6.893-19.86-6.408-24.765 9.738 3.758 9.738 3.758.925-19.97 5.716-21.637 14.09 8.261 14.311 19.965-11.694 26.263-11.694 26.263z"
          fill="#cc8a59"
        />
        <g data-name="Group 1240">
          <g data-name="Rectangle 1119" fill="#fff">
            <path d="M465.525 132.087l.04-.013 15.97-5.368c2.786-.937 5.831.504 6.788 3.212l14.445 40.886a5.012 5.012 0 01-.215 3.876 5.241 5.241 0 01-3.045 2.682l-.04.014-15.969 5.368c-2.786.936-5.832-.505-6.789-3.213l-14.444-40.886a5.013 5.013 0 01.215-3.875 5.24 5.24 0 013.044-2.683z" />
            <path
              d="M465.851 133.033a4.247 4.247 0 00-2.469 2.172 4.019 4.019 0 00-.173 3.107l14.445 40.886c.776 2.196 3.255 3.36 5.526 2.597l15.97-5.368.032-.01a4.247 4.247 0 002.47-2.172c.473-.98.534-2.084.172-3.107l-14.444-40.886c-.776-2.196-3.255-3.361-5.527-2.598l-15.97 5.368-.032.011m-.652-1.892l.048-.016 15.969-5.368c3.306-1.111 6.911.603 8.05 3.828l14.445 40.886c1.134 3.21-.6 6.708-3.877 7.837l-.047.016-15.969 5.368c-3.307 1.112-6.912-.602-8.051-3.828l-14.445-40.886c-1.134-3.21.6-6.708 3.877-7.837z"
              fill="#434343"
            />
          </g>
          <path
            data-name="Path 1684"
            d="M464.435 160.037s-1.063-12.35.83-13.462 4.152 5.857 5.405 11.86a29.95 29.95 0 01-.392 12.178z"
            fill="#cc8a59"
          />
          <path
            data-name="Path 1685"
            d="M478.62 127.638l-10.915 3.673c-.546.188-.188.9.001 1.437s.96 1.13 1.516.942l10.13-3.235c.546-.188.78-1.389.595-1.927s-.774-1.075-1.327-.89z"
            fill="#434343"
          />
          <g
            data-name="Mask Group 2"
            transform="rotate(-20 657.377 -1266.597)"
            clipPath="url(#prefix__d)">
            <g data-name="gift (2)">
              <path
                data-name="Path 8"
                d="M11.83 1.879C11.371.97 10.822.508 10.197.508c-.72 0-1.467.623-2.223 1.852-.1.157-.187.315-.271.466a11.102 11.102 0 00-.271-.466C6.678 1.131 5.93.508 5.21.508c-.625 0-1.175.46-1.633 1.371a1.48 1.48 0 00-.055 1.458 2.763 2.763 0 002.021 1.077 12.106 12.106 0 002.125.178h.074a12.106 12.106 0 002.125-.178 2.76 2.76 0 002.021-1.077 1.481 1.481 0 00-.057-1.458z"
                fill="#da4453"
              />
              <path
                data-name="Path 9"
                d="M14.446 7.078a.662.662 0 00-.642-.68H1.605a.662.662 0 00-.642.68v8.049a.662.662 0 00.642.68h12.2a.662.662 0 00.642-.68z"
                fill="#ffca3b"
              />
              <path
                data-name="Path 10"
                d="M15.406 7.649a.662.662 0 01-.642.68H.642A.662.662 0 010 7.649v-3.4a.662.662 0 01.642-.68h14.122a.662.662 0 01.642.68z"
                fill="#ffdb57"
              />
              <path
                data-name="Rectangle 10"
                fill="#ed5564"
                d="M6.098 3.569h3.21v4.759h-3.21z"
              />
              <path
                data-name="Path 11"
                d="M.963 9h13.483v-.65H.963z"
                opacity={0.134}
              />
              <path
                data-name="Rectangle 11"
                fill="#da4453"
                d="M6.098 8.328h3.21v7.479h-3.21z"
              />
              <path
                data-name="Path 12"
                d="M6.098 9h3.21v-.65h-3.21z"
                opacity={0.134}
              />
            </g>
          </g>
          <g
            data-name="Mask Group 2"
            transform="rotate(-20 657.377 -1266.597)"
            clipPath="url(#prefix__d)">
            <g data-name="gift (2)">
              <path
                data-name="Path 8"
                d="M11.83 1.879C11.371.97 10.822.508 10.197.508c-.72 0-1.467.623-2.223 1.852-.1.157-.187.315-.271.466a11.102 11.102 0 00-.271-.466C6.678 1.131 5.93.508 5.21.508c-.625 0-1.175.46-1.633 1.371a1.48 1.48 0 00-.055 1.458 2.763 2.763 0 002.021 1.077 12.106 12.106 0 002.125.178h.074a12.106 12.106 0 002.125-.178 2.76 2.76 0 002.021-1.077 1.481 1.481 0 00-.057-1.458z"
                fill="#da4453"
              />
              <path
                data-name="Path 9"
                d="M14.446 7.078a.662.662 0 00-.642-.68H1.605a.662.662 0 00-.642.68v8.049a.662.662 0 00.642.68h12.2a.662.662 0 00.642-.68z"
                fill="#ffca3b"
              />
              <path
                data-name="Path 10"
                d="M15.406 7.649a.662.662 0 01-.642.68H.642A.662.662 0 010 7.649v-3.4a.662.662 0 01.642-.68h14.122a.662.662 0 01.642.68z"
                fill="#ffdb57"
              />
              <path
                data-name="Rectangle 10"
                fill="#ed5564"
                d="M6.098 3.569h3.21v4.759h-3.21z"
              />
              <path
                data-name="Path 11"
                d="M.963 9h13.483v-.65H.963z"
                opacity={0.134}
              />
              <path
                data-name="Rectangle 11"
                fill="#da4453"
                d="M6.098 8.328h3.21v7.479h-3.21z"
              />
              <path
                data-name="Path 12"
                d="M6.098 9h3.21v-.65h-3.21z"
                opacity={0.134}
              />
            </g>
          </g>
        </g>
        <g transform="translate(-887 -1765)">
          <rect
            data-name="Rectangle 1126"
            width={255}
            height={255}
            rx={26}
            transform="translate(1501 2033)"
            fill="#f45deb"
          />
          <path
            data-name="Subtraction 4"
            d="M1755.523 2063.002v199.33a25.978 25.978 0 01-26 26h-203a25.937 25.937 0 01-19.523-8.828l248.523-216.501z"
            fill="#fff"
            opacity={0.09}
          />
          <g
            data-name="Mask Group 456"
            transform="translate(-298 -63)"
            clipPath="url(#prefix__e)">
            <g
              data-name="Mask Group 452"
              transform="translate(1731.277 2033)"
              clipPath="url(#prefix__f)">
              <g data-name="Group 1241">
                <g data-name="Group 1239">
                  <path
                    data-name="Path 367"
                    d="M111.724 263.94c6.495-47.69 36.26-86.841 31.294-117.385s-3.857-46.436 15.507-62.897 44.572-13.791 69.178 8.803 10.017 69.642 40.196 109.277 27.434 98.546-11.965 120.066-172.283 35.544-138.906 15.516-11.803-25.69-5.304-73.38z"
                    fill="#e8c583"
                  />
                  <path
                    data-name="Path 1593"
                    d="M68.533 186.615l68.264 43.216s45.339-5.395 52.035-16.569-28.68-22.17-28.68-22.17L72.858 156.94z"
                    fill="#fafafa"
                    opacity={0.998}
                  />
                  <g data-name="Group 1149">
                    <g data-name="Group 1148">
                      <g data-name="neck">
                        <path
                          data-name="Rectangle 2"
                          fill="#ffe2c9"
                          d="M175.512 138.375h31.649v49.393h-31.649z"
                        />
                        <path
                          data-name="Intersection 2"
                          d="M185.826 181.928a46.586 46.586 0 0021.335-22.244v-11.018h-31.649v36.069a28.136 28.136 0 0010.314-2.807z"
                          fill="#f5c5a4"
                        />
                      </g>
                      <g data-name="face">
                        <path
                          data-name="Path 4"
                          d="M220.31 136.782c8.746-21.61-4.431-43.713-12.341-47.918s-25.415-10.97-39.144-3.352-23.889 16.718-20.787 39.35 19.876 52.336 32.837 51.784 30.688-18.245 39.435-39.864z"
                          fill="#ffe2c9"
                        />
                        <path
                          data-name="Intersection 1"
                          d="M174.454 83.249a26.372 26.372 0 00-5.632 2.314c-13.727 7.612-23.888 16.712-20.787 39.338 2.603 19.015 14.876 43.029 26.419 49.874z"
                          fill="#f5c5a4"
                        />
                        <path
                          data-name="Path 6"
                          d="M175.17 131.408l-6.057 16.052 9.531 7.532z"
                          fill="#ffe2c9"
                        />
                        <path
                          data-name="Path 7"
                          d="M186.237 133.164l.681-.766a10.984 10.984 0 017.089-3.743 51.7 51.7 0 0110.491 1.688"
                          fill="none"
                          stroke="#360e0e"
                          strokeWidth={1.5}
                        />
                        <path
                          data-name="Path 8"
                          d="M170.573 133.164s-3.165-4.509-6.906-4.509a41.294 41.294 0 00-9.32 1.688"
                          fill="none"
                          stroke="#360e0e"
                          strokeWidth={1.5}
                        />
                        <path
                          data-name="Path 9"
                          d="M196.902 128.459c-1.421-.479-4.285-.122-4.852 1.492a2.793 2.793 0 00.035 2.247 2.9 2.9 0 001.693 1.525c1.601.571 4.1.133 4.67-1.477a2.876 2.876 0 00-1.55-3.788z"
                          fill="#360e0e"
                        />
                        <path
                          data-name="Path 1638"
                          d="M165.253 128.459c-1.421-.479-4.285-.122-4.852 1.492a2.793 2.793 0 00.035 2.247 2.9 2.9 0 001.693 1.525c1.601.571 4.1.133 4.67-1.477a2.876 2.876 0 00-1.55-3.788z"
                          fill="#360e0e"
                        />
                        <path
                          data-name="Path 11"
                          d="M183.091 123.072l1.389 3.028a31.761 31.761 0 0111.838-4.808 40.534 40.534 0 0113.75.882 26.185 26.185 0 00-12.464-3.068 43.544 43.544 0 00-14.513 3.966z"
                          fill="#ac7d00"
                        />
                        <path
                          data-name="Path 12"
                          d="M172.042 123.076l-1.125 3.043a21.1 21.1 0 00-9.03-4.619 24.671 24.671 0 00-10.608 1.102 17.443 17.443 0 019.647-3.262 27.109 27.109 0 0111.116 3.736z"
                          fill="#ac7d00"
                        />
                        <path
                          data-name="Path 13"
                          d="M174.554 157.31c.361.023 1.494.043 2.515 0 1.705-.031 1.517.115 4.538 0s7.545-.461 7.545-.461-5.789 7.874-12.083 8.555-9.262-7.063-9.262-7.063a24.533 24.533 0 016.747-1.03z"
                          fill="#e083aa"
                        />
                        <path
                          data-name="Path 1596"
                          d="M170.572 159.62l4.948-.43 9.151-.473a22.934 22.934 0 01-8.505 3.585 6.842 6.842 0 01-5.593-2.682z"
                          fill="#fff"
                        />
                      </g>
                      <path
                        data-name="Path 18"
                        d="M230.943 193.859l-22.171-6.554h-34.309s-11.791 1.488-17.512 6.555c-8.475 7.493-11.463 15.913-22.653 33.9-17.788 28.607 2.812 34.244 7.385 64.882s0 64.3 0 64.3h100.281s-21.17-34.046-23.456-71.234 16.782-45.222 16.782-68.239-4.347-23.61-4.347-23.61z"
                        fill="#fff"
                      />
                      <path
                        data-name="Path 24"
                        d="M206.946 182.635v5.493s-29.042 15.394-37.26 13.042 5.7-13.865 5.7-13.865z"
                        fill="#ffe2c9"
                      />
                      <path
                        data-name="Path 25"
                        d="M239.5 320.955l-18.85-79.128s13.869-31.314 24.164-30.656 11.559 32.823 11.559 32.823l8.708 82.961z"
                        fill="#fff"
                        opacity={0.998}
                      />
                      <path
                        data-name="Path 29"
                        d="M228.519 194.765l-10.615-3.168s19.04 1.235 25.741 9.846 11.683 27.748 11.683 27.748l-.579.7-30.912 27.61s-6.9-28.261-6.864-29.7l.93-36.2"
                        fill="#fff"
                      />
                    </g>
                    <path
                      data-name="Path 1590"
                      d="M157.753 99.389s27.225-.64 42.046 6.732c8.194 4.077 9.4 15.846 10.304 23.682s-4.022 38.315-4.022 38.315l2.663-8.353a40.816 40.816 0 0017.596-21.887c4.467-14.621 12.49-31.306-1.457-45.75-12.757-10.021-11.752-1.593-18.3-4.593-8.236-3.778-13.73-7.146-23.313-6.916-16.051.385-25.517 18.77-25.517 18.77z"
                      fill="#e8c583"
                    />
                    <path
                      data-name="Path 1591"
                      d="M206.3 98.896l-20.941 13.866s-10.5 10.222-36.414 13.653c-8.523 1.13 1.936-26.875 1.936-26.875s21.54-31.252 43.122-24.417 12.296 23.773 12.296 23.773z"
                      fill="#e8c583"
                    />
                    <path
                      data-name="Path 1592"
                      d="M213.704 130.096a11.749 11.749 0 015.346-.959c1.864.478 3.774 3.95 1.903 9.156s-9.391 11.663-9.391 11.663z"
                      fill="#ffe2c9"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
          <path
            data-name="Path 1594"
            d="M1513.486 2158.398c7.139-3.227 18.312-17.45 6.829-46.752s-24.172-65.49-24.172-65.49l-11.752 1.78s3.059 41.26 9.03 76.504 12.933 37.188 20.065 33.958z"
            fill="#fafafa"
          />
          <path
            data-name="Path 1595"
            d="M1496.15 2046.252s8.266-19.335 8.125-24.261-9.98 3.073-9.98 3.073.47-19.995-4.193-21.994-14.638 7.258-15.675 18.92 9.83 27.022 9.83 27.022z"
            fill="#f5c5a4"
          />
          <g data-name="Group 1240">
            <g data-name="Rectangle 1119" fill="#fff">
              <path d="M1469.143 2040.362a5.238 5.238 0 01-3.044-2.68 5.01 5.01 0 01-.216-3.873l14.426-40.866c.956-2.706 3.999-4.148 6.784-3.212l15.961 5.36.04.014a5.238 5.238 0 013.043 2.68 5.01 5.01 0 01.216 3.873l-14.425 40.865c-.956 2.707-4 4.148-6.784 3.213l-15.961-5.36-.04-.014z" />
              <path
                d="M1502.768 1996.05l-.032-.01-15.961-5.361c-2.27-.763-4.748.402-5.523 2.597l-14.426 40.865a4.016 4.016 0 00.174 3.106 4.245 4.245 0 002.468 2.17l.033.01 15.96 5.36c2.271.763 4.749-.402 5.524-2.596l14.425-40.866a4.016 4.016 0 00-.173-3.105 4.245 4.245 0 00-2.469-2.17m.652-1.89c3.274 1.127 5.009 4.622 3.876 7.831l-14.426 40.865c-1.138 3.224-4.74 4.938-8.045 3.828l-15.96-5.36a6.595 6.595 0 01-.048-.017c-3.275-1.127-5.01-4.623-3.877-7.831l14.426-40.866c1.138-3.224 4.74-4.937 8.045-3.827l15.961 5.36.048.017z"
                fill="#434343"
              />
            </g>
            <path
              data-name="Path 1684"
              d="M1504.218 2023.027s1.066-12.35-.828-13.462-4.154 5.857-5.403 11.86a29.95 29.95 0 00.388 12.178z"
              fill="#f5c5a4"
            />
            <path
              data-name="Path 1685"
              d="M1490.032 1990.642l10.91 3.667c.545.188.188.9-.001 1.437s-.967 1.126-1.514.942l-10.123-3.23c-.55-.186-.791-1.389-.597-1.927s.773-1.075 1.325-.889z"
              fill="#434343"
            />
          </g>
          <g
            data-name="Mask Group 2"
            transform="rotate(20 -4951.01 5204.274)"
            clipPath="url(#prefix__d)">
            <g data-name="gift (2)">
              <path
                data-name="Path 8"
                d="M11.83 1.879C11.371.97 10.822.508 10.197.508c-.72 0-1.467.623-2.223 1.852-.1.157-.187.315-.271.466a11.102 11.102 0 00-.271-.466C6.678 1.131 5.93.508 5.21.508c-.625 0-1.175.46-1.633 1.371a1.48 1.48 0 00-.055 1.458 2.763 2.763 0 002.021 1.077 12.106 12.106 0 002.125.178h.074a12.106 12.106 0 002.125-.178 2.76 2.76 0 002.021-1.077 1.481 1.481 0 00-.057-1.458z"
                fill="#da4453"
              />
              <path
                data-name="Path 9"
                d="M14.446 7.078a.662.662 0 00-.642-.68H1.605a.662.662 0 00-.642.68v8.049a.662.662 0 00.642.68h12.2a.662.662 0 00.642-.68z"
                fill="#ffca3b"
              />
              <path
                data-name="Path 10"
                d="M15.406 7.649a.662.662 0 01-.642.68H.642A.662.662 0 010 7.649v-3.4a.662.662 0 01.642-.68h14.122a.662.662 0 01.642.68z"
                fill="#ffdb57"
              />
              <path
                data-name="Rectangle 10"
                fill="#ed5564"
                d="M6.098 3.569h3.21v4.759h-3.21z"
              />
              <path
                data-name="Path 11"
                d="M.963 9h13.483v-.65H.963z"
                opacity={0.134}
              />
              <path
                data-name="Rectangle 11"
                fill="#da4453"
                d="M6.098 8.328h3.21v7.479h-3.21z"
              />
              <path
                data-name="Path 12"
                d="M6.098 9h3.21v-.65h-3.21z"
                opacity={0.134}
              />
            </g>
          </g>
        </g>
        <g>
          <path
            data-name="Path 1698"
            d="M58 399.999h203a26 26 0 0126 26v203a26 26 0 01-26 26H58a26 26 0 01-26-26v-203a26 26 0 0126-26z"
            fill="#3a20d9"
          />
          <path
            data-name="Subtraction 6"
            d="M44.424 650.324a25.979 25.979 0 01-12.457-22.199V425.68a25.978 25.978 0 0126-26H260.58a26.007 26.007 0 0123.875 15.689z"
            fill="#06002e"
            opacity={0.09}
          />
          <g
            data-name="Mask Group 457"
            transform="translate(33 399.999)"
            clipPath="url(#prefix__g)">
            <g data-name="Group 1247">
              <g
                data-name="Mask Group 454"
                clipPath="url(#prefix__h)"
                transform="translate(-78.975)">
                <g data-name="Group 1195">
                  <g data-name="Group 1194">
                    <g data-name="Group 857">
                      <g data-name="Group 855">
                        <g
                          data-name="Mask Group 400"
                          clipPath="url(#prefix__i)"
                          transform="translate(12.975 -.4)">
                          <g data-name="Group 881">
                            <g data-name="Group 880">
                              <path
                                data-name="Path 975"
                                d="M239.628 311.027l16.056-113.611s-.785-30.274-14.267-39.393l-40.333-20.224h-36.248l-56.388 36.286 35.11 136.948z"
                                fill="#ffcca0"
                              />
                              <path
                                data-name="Path 988"
                                d="M164.656 110.997v39.31h40.959s-10.072-15.582-5.035-39.31z"
                                fill="#ffcca0"
                              />
                              <path
                                data-name="Path 989"
                                d="M187.455 134.329c8.568 2.406 11.472-7.923 11.472-7.923s-.814-6.16 2.639-15.408h-36.912v5.783c4.848 7.785 14.233 15.142 22.8 17.548z"
                                fill="#e9b287"
                              />
                              <path
                                data-name="Path 992"
                                d="M136.9 307.732c.086 4.042-5.957 46.34-3.423 46.885.017 0 69.14 16.171 106.005 0l.146-43.585 15.611-56.128 1.765-20.334-.961-51.439s-1.05-10.946-3.281-17.018-5.641-7.27-5.641-7.27l-46.037-21.04 3.466 10.58s-3.286 19.108-13.211 16.465-26.488-27.036-26.488-27.036l-53.715 32.2c3.449 11.61-1.169 28.067 2.271 39.681 6.369 21.4 12.566 42.871 19.127 64.215-.008 0 5.43 23.149 4.366 33.824z"
                                fill="#fff"
                              />
                            </g>
                          </g>
                        </g>
                      </g>
                      <path
                        data-name="Path 966"
                        d="M178.365 69.724a60.853 60.853 0 00-10.188-2.486c-2.186.072-5.225 3.67-4.514 10.31s7.295 16.24 7.295 16.24z"
                        fill="#ffcca0"
                      />
                      <path
                        data-name="Path 967"
                        d="M211.33 69.91l8.481 18.312-10.492 3.838z"
                        fill="#ffcca0"
                      />
                      <g data-name="Group 856">
                        <path
                          data-name="Path 968"
                          d="M205.22 78.541l-.7-.788a10.941 10.941 0 00-7.215-3.803 50.252 50.252 0 00-10.544 1.96"
                          fill="none"
                          stroke="#360e0e"
                          strokeWidth={0.662}
                        />
                        <path
                          data-name="Path 969"
                          d="M197.067 73.69c1.696-.487 4.963-.079 5.446 1.64s-1.99 4.097-3.682 4.594a3.2 3.2 0 01-2.444-.293 3.165 3.165 0 01-1.507-1.931 3.247 3.247 0 012.188-4.01z"
                          fill="#360e0e"
                        />
                      </g>
                      <path
                        data-name="Path 970"
                        d="M208.232 65.401l-.725 3.853s-6.258-1.71-11.708-3.098a24.41 24.41 0 00-10.545-.146 10.43 10.43 0 018.852-3.11c5.745.584 14.126 2.501 14.126 2.501z"
                        fill="#6a2c14"
                      />
                      <path
                        data-name="Path 971"
                        d="M214.463 100.68a13.385 13.385 0 01-1.699.059c-1.455.02-3.175.111-3.175.111l-7.262 1.001s6.724 4.182 10.631 4.47 8.067-4.32 8.067-4.32a19.732 19.732 0 00-6.562-1.322z"
                        fill="#e3a275"
                      />
                      <path
                        data-name="Path 972"
                        d="M216.413 76.832s4.586-3.576 7.561-2.988A21.207 21.207 0 01228 74.907"
                        fill="none"
                        stroke="#360e0e"
                        strokeWidth={0.662}
                      />
                      <path
                        data-name="Path 973"
                        d="M222.759 73.355c1.4.024 3.429.492 3.401 2.042a4.373 4.373 0 01-3.498 3.557 2.678 2.678 0 01-2.495-2.834 2.716 2.716 0 01.733-1.922 2.636 2.636 0 011.859-.843z"
                        fill="#360e0e"
                      />
                      <path
                        data-name="Path 974"
                        d="M217.192 65.292l.38 3.494s3.476-.892 6.508-1.57a8.6 8.6 0 015.862 1.157s-1.721-4-4.918-4.13a34.092 34.092 0 00-7.832 1.052z"
                        fill="#6a2c14"
                      />
                    </g>
                    <path
                      data-name="Path 964"
                      d="M229.27 90.275c-2.54 2.57-3.493 6.443-4.723 9.863-9.49-12.7-16.471-37.647-2.957-49.083 20.306-17.181 20.715 26.049 7.68 39.22z"
                      fill="#261008"
                    />
                    <g data-name="face">
                      <path
                        data-name="Path 4"
                        d="M162.838 89.18c-11.855-21.21-1.896-46.04 5.388-51.528s23.781-14.994 38.587-9.026 26.258 13.987 26.444 37.936-8.636 55.727-25.284 58.45-33.277-14.611-45.135-35.832z"
                        fill="#ffcca0"
                      />
                      <path
                        data-name="Intersection 1"
                        d="M214.17 122.608c4.626-3.143 8.983-9.139 12.112-17.083a113.261 113.261 0 006.978-38.924c-.174-23.946-11.631-31.958-26.435-37.925a25.945 25.945 0 00-5.957-1.6z"
                        fill="#e9b287"
                      />
                      <path
                        data-name="Path 6"
                        d="M207.744 77.066l7.938 18.25-10.778 2.815z"
                        fill="#ffcca0"
                      />
                      <path
                        data-name="Path 7"
                        d="M197.022 82.637l-.791-.697a10.915 10.915 0 00-7.618-2.887 50.314 50.314 0 00-10.228 3.238"
                        fill="none"
                        stroke="#360e0e"
                      />
                      <path
                        data-name="Path 8"
                        d="M212.655 80.418s4.214-5.641 7.949-6.174c3.186-.238 4.683.422 7.835.946"
                        fill="none"
                        stroke="#360e0e"
                      />
                      <path
                        data-name="Path 9"
                        d="M188.643 79.732a3.12 3.12 0 014.173.118 2.7 2.7 0 01.745 1.919 2.437 2.437 0 01-.842 1.8 2.611 2.611 0 01-1.887.823 2.787 2.787 0 01-1.96-.786 2.761 2.761 0 01-.23-3.874zM219.263 74.8a3.12 3.12 0 014.174.118 2.7 2.7 0 01.745 1.918 2.437 2.437 0 01-.842 1.8 2.611 2.611 0 01-1.888.823 2.787 2.787 0 01-1.959-.785 2.761 2.761 0 01-.23-3.875z"
                        fill="#360e0e"
                      />
                      <path
                        data-name="Path 12"
                        d="M209.407 67.611l1.14 3.344s5.462-1.964 10.233-3.57a21.11 21.11 0 019.606-.673 10.243 10.243 0 00-8.535-2.57 90.42 90.42 0 00-12.444 3.466z"
                        fill="#261008"
                      />
                      <path
                        data-name="Path 34"
                        d="M198.257 68.981l-.256 3.915s-6.42-.931-12-1.638a24.426 24.426 0 00-10.488 1.142 10.457 10.457 0 018.416-4.175c5.776-.121 14.328.756 14.328.756z"
                        fill="#261008"
                      />
                      <path
                        data-name="Path 13"
                        d="M211.046 104.693a18.7 18.7 0 01-1.99.28c-1.707.209-3.72.522-3.72.522l-8.837.131s8.705 5.105 13.327 4.879 8.966-6.213 8.966-6.213a44.471 44.471 0 00-7.747.4z"
                        fill="#d6905f"
                      />
                    </g>
                    <path
                      data-name="Path 1001"
                      d="M184.962 45.98s-15.254 18.837-17.981 30.86 3.645 25.73 3.651 25.736c-.107-.427-2.003-1.397-2.391-1.693a70.9 70.9 0 01-8.733-10.569c-8.463-12.53-5.38-14.571-7.871-22.1-1.701-5.142 1.51-27.208 9.516-34.764 0 0 19.534-1.966 23.81 12.53z"
                      fill="#261008"
                    />
                    <path
                      data-name="Path 1017"
                      d="M209.491 57.542c-30.592 4.754-34.83-12.136-34.83-12.136l-13.432-11.473s5.39-12.63 28.031-16.783c0 0 19.079-1.389 34.097 9.187s20.54 24.532 17.074 32.335-.35-5.883-30.94-1.13z"
                      fill="#261008"
                    />
                    <path
                      data-name="Path 975"
                      d="M168.142 75.146a11.48 11.48 0 00-5.327-1.296c-1.901.397-4.009 3.928-2.395 9.482s8.847 12.736 8.847 12.736z"
                      fill="#ffcca0"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
          <g data-name="Group 1246">
            <path
              data-name="Rectangle 1140"
              d="M179.568 602.47l18.306 1.575a3.97 3.97 0 013.63 4.297l-3.645 41.123a4 4 0 01-4.33 3.611l-18.306-1.575a3.97 3.97 0 01-3.63-4.297l3.645-41.121a4 4 0 014.33-3.614z"
              fill="#e0e0e0"
            />
            <path
              data-name="Rectangle 1141"
              d="M178.602 604.007l6.367.548a1.588 1.588 0 011.455 1.719l-.564 6.326a1.6 1.6 0 01-1.732 1.445l-6.363-.548a1.588 1.588 0 01-1.456-1.719l.56-6.325a1.6 1.6 0 011.733-1.446z"
              fill="#fff"
              opacity={0.211}
            />
            <g data-name="Ellipse 28" fill="#2b2b2b">
              <path d="M179.043 607.908h-.001a1.454 1.454 0 01-1.328-1.573 1.464 1.464 0 011.587-1.322 1.455 1.455 0 011.329 1.573 1.464 1.464 0 01-1.587 1.322z" />
              <path
                d="M179.29 605.147a1.33 1.33 0 00-1.441 1.2 1.321 1.321 0 001.206 1.426 1.33 1.33 0 001.44-1.2 1.32 1.32 0 00-1.205-1.426m.024-.268a1.588 1.588 0 011.45 1.719 1.598 1.598 0 01-1.734 1.444 1.588 1.588 0 01-1.45-1.719 1.598 1.598 0 011.734-1.444z"
                fill="#262626"
              />
            </g>
            <g data-name="Ellipse 29" fill="#2b2b2b">
              <path d="M178.623 611.856h-.002a1.454 1.454 0 01-1.327-1.573 1.464 1.464 0 011.587-1.322 1.455 1.455 0 011.329 1.572 1.464 1.464 0 01-1.587 1.323z" />
              <path
                d="M178.869 609.095a1.33 1.33 0 00-1.44 1.2c-.031.348.076.688.3.957.229.271.55.438.906.47a1.33 1.33 0 001.44-1.2 1.32 1.32 0 00-1.205-1.426l-.001-.001m.025-.268a1.588 1.588 0 011.45 1.718 1.598 1.598 0 01-1.734 1.445 1.588 1.588 0 01-1.45-1.719 1.598 1.598 0 011.734-1.444z"
                fill="#262626"
              />
            </g>
            <g data-name="Ellipse 30" fill="#2b2b2b">
              <path d="M183.812 608.402h-.002a1.454 1.454 0 01-1.327-1.573 1.464 1.464 0 011.586-1.322 1.455 1.455 0 011.329 1.572 1.464 1.464 0 01-1.586 1.323z" />
              <path
                d="M184.057 605.641a1.33 1.33 0 00-1.44 1.2 1.321 1.321 0 001.206 1.426 1.33 1.33 0 001.44-1.2 1.32 1.32 0 00-1.205-1.426m.024-.268a1.588 1.588 0 011.45 1.718 1.598 1.598 0 01-1.734 1.445 1.588 1.588 0 01-1.45-1.719 1.598 1.598 0 011.734-1.444z"
                fill="#262626"
              />
            </g>
          </g>
          <g data-name="Group 861" fill="#ffcca0">
            <path
              data-name="Path 986"
              d="M117.916 710.013l-2.487-114.5c-7.735-26.55-29.505-24.97-29.505-24.97-20.1 2.877-18.709 25.173-18.709 25.173l19.347 110.092s3.275 25.037 14.432 22.413c.006-.002 19.257-2.448 16.922-18.208z"
            />
            <path
              data-name="Path 987"
              d="M89.596 699.408s20.895-19.896 41.153-34.522a289.264 289.264 0 0139.877-23.98l7.43 8.928s-46.984 63.885-70.723 76.7c.001.001-23.593-7.487-17.737-27.126z"
            />
          </g>
          <path
            data-name="Path 1694"
            d="M168.63 639.737l-1.086-10.298 6.917-9.022-.528 8.35 28.62-9.846 1.476 13.991-17.114 16.103-14.64 6.777-6.379-8.525z"
            fill="#ffcca0"
          />
          <path
            data-name="Path 1667"
            d="M130.919 538.255s-56.182 23.739-62.393 42.611 4.667 54.066 4.667 54.066l47.4 13.032 5.13-76.007-2.854-1.651z"
            fill="#fff"
          />
        </g>
        <g>
          <path
            data-name="Path 1696"
            d="M1167 400h203a26 26 0 0126 26v203a26 26 0 01-26 26h-203a26 26 0 01-26-26V426a26 26 0 0126-26z"
            fill="#f0518a"
          />
          <path
            data-name="Subtraction 5"
            d="M1395.523 400.001v229.331a25.979 25.979 0 01-26 26h-208.115a25.94 25.94 0 01-20.015-9.4l254.13-245.93z"
            fill="#fff"
            opacity={0.09}
          />
          <g
            data-name="Mask Group 455"
            transform="translate(900 -1883)"
            clipPath="url(#prefix__j)">
            <g data-name="Group 1245">
              <g data-name="Group 850">
                <g data-name="Group 848">
                  <path
                    data-name="Path 952"
                    d="M350.827 2552.846l41.044-90.095s26.786-15.544 33.673-9.484-9.72 30.425-9.72 30.425l-38.995 65.792z"
                    fill="#956442"
                    opacity={0.998}
                  />
                  <g data-name="Group 840">
                    <path
                      data-name="Ellipse 1"
                      d="M438.805 2314.651c20.435 5.205 32.264 28.81 26.419 52.725s-27.149 39.079-47.586 33.877-32.263-28.809-26.418-52.724 27.149-39.082 47.585-33.878z"
                      fill="#140665"
                    />
                    <g data-name="neck">
                      <path
                        data-name="Rectangle 2"
                        fill="#b47a52"
                        d="M418.803 2377.838h27.912v45.59h-27.912z"
                      />
                      <path
                        data-name="Intersection 2"
                        d="M427.898 2418.036a42.21 42.21 0 0018.817-20.53v-10.17h-27.912v33.291a23.962 23.962 0 009.1-2.591z"
                        fill="#956442"
                      />
                    </g>
                    <g data-name="face">
                      <path
                        data-name="Path 4"
                        d="M452.691 2381.266c12.211-17.442 5.776-40.102-.073-45.59s-19.342-15.357-32.753-11.53-24.094 9.764-26.394 30.702 5.552 51.187 16.76 53.517 30.248-9.648 42.46-27.1z"
                        fill="#b47a52"
                      />
                      <path
                        data-name="Intersection 1"
                        d="M425.18 2323.35a22.504 22.504 0 00-5.328.84c-13.41 3.826-24.094 9.764-26.39 30.69-1.933 17.597 3.31 41.767 11.687 50.411z"
                        fill="#1c0b00"
                        opacity={0.2}
                      />
                      <path
                        data-name="Path 6"
                        d="M415.25 2366.62l-8.695 13.054 6.505 8.82z"
                        fill="#b47a52"
                      />
                      <path
                        data-name="Path 7"
                        d="M424.333 2370.602l.752-.534a9.465 9.465 0 016.882-1.81 44.07 44.07 0 018.606 3.796"
                        fill="none"
                        stroke="#190c0c"
                        strokeWidth={1.3086465699999998}
                      />
                      <path
                        data-name="Path 8"
                        d="M410.934 2367.19s-1.722-4.727-4.92-5.542a34.905 34.905 0 00-8.344-.52"
                        fill="none"
                        stroke="#190c0c"
                        strokeWidth={1.3086465699999998}
                      />
                      <path
                        data-name="Path 9"
                        d="M431.567 2367.614c-1.5-.354-4.331.157-4.68 1.694s1.922 3.503 3.417 3.856a2.79 2.79 0 003.354-2.132 2.851 2.851 0 00-2.09-3.419z"
                        fill="#190c0c"
                      />
                      <path
                        data-name="Path 10"
                        d="M404.492 2360.72c-1.5-.355-3.784-.438-4.132 1.095a4.684 4.684 0 002.869 4.454 2.79 2.79 0 003.353-2.132 2.851 2.851 0 00-2.09-3.419z"
                        fill="#190c0c"
                      />
                      <path
                        data-name="Path 11"
                        d="M423.85 2360.883l.53 3.014a27.109 27.109 0 0111.177-1.726 34.383 34.383 0 0111.57 3.788 22.494 22.494 0 00-9.992-5.465 36.907 36.907 0 00-13.284.39z"
                        fill="#140665"
                      />
                      <path
                        data-name="Path 12"
                        d="M414.399 2358.48l-1.626 2.48a18.571 18.571 0 00-6.722-6.098 20.85 20.85 0 00-9.31-1.333 14.847 14.847 0 018.968-.814 23.465 23.465 0 018.689 5.764z"
                        fill="#140665"
                      />
                      <path
                        data-name="Path 13"
                        d="M409.966 2388.734c1.465.344 11.68 3.71 11.68 3.71s-8.594 3.949-12.592 3.316-6.32-7.543-6.32-7.543a46.288 46.288 0 017.232.517z"
                        fill="#900707"
                      />
                    </g>
                    <g fill="#140665">
                      <path
                        data-name="Path 14"
                        d="M454.816 2328.542s1.124 8.315-14.74 15.21-35.69.58-44.8 16.657-7.774-19.871 2.418-30.8 21.418-14.572 35.199-13.696 21.923 12.629 21.923 12.629z"
                      />
                      <path
                        data-name="Path 15"
                        d="M449.507 2333.78a237.045 237.045 0 011.094 35.034 56.833 56.833 0 01-10.528 28.028s21.9-18.823 23.774-36.89-10.992-35.087-10.992-35.087z"
                      />
                    </g>
                    <path
                      data-name="Path 18"
                      d="M467.69 2429.05l-19.552-6.05h-30.26s-10.4 1.373-15.445 6.05c-7.474 6.918-10.111 14.688-19.974 31.291-15.689 26.4 2.477 31.607 6.515 59.886.186 1.244 7.628 10.92 7.841 12.748a87.484 87.484 0 01-7.845 47.166s29.009 18.006 51.119 18.006a116.814 116.814 0 0039.727-7.159s-21.074-42.833-23.089-77.158 14.8-41.739 14.8-62.983-3.837-21.797-3.837-21.797z"
                      fill="#fff"
                    />
                    <path
                      data-name="Path 24"
                      d="M446.528 2418.69v5.07s-25.613 14.208-32.861 12.037 5.024-12.8 5.024-12.8z"
                      fill="#b47a52"
                    />
                    <path
                      data-name="Path 25"
                      d="M463.361 2533.423l-13.488-68.212s12.232-28.9 21.313-28.294 10.194 30.296 10.194 30.296l6.532 77.37z"
                      fill="#b47a52"
                      opacity={0.998}
                    />
                    <path
                      data-name="Path 29"
                      d="M447.247 2421.267s17-1.274 22.906 6.674 10.3 25.614 10.3 25.614l-.512.642-27.262 25.485s-15.423-42.274-13.158-51.74a22.514 22.514 0 000 2.685"
                      fill="#fff"
                    />
                  </g>
                </g>
                <path
                  data-name="Ellipse 9"
                  d="M482.98 2318.912c7.079 8.317 6.527 20.638-1.232 27.52s-19.788 5.72-26.867-2.597-6.526-20.636 1.232-27.52 19.788-5.72 26.868 2.597z"
                  fill="#140665"
                />
              </g>
              <g data-name="Group 1244">
                <g data-name="Group 4">
                  <path
                    data-name="Path 49"
                    d="M381.58 2533.394l-18.317-74.943a9.971 9.971 0 00-5.769-5.936c-4.566-1.809-12.5-1.3-12.5-1.3H243.667s-4.537.143-6.413 3.015-1.092 8.476-1.092 8.476l15.557 69.6a16.379 16.379 0 003.83 6.957 13.792 13.792 0 006.923 2.916h117.836z"
                    fill="#d8d8d8"
                  />
                  <path
                    data-name="Path 49"
                    d="M376.944 2530.55l-17-69.739a9.269 9.269 0 00-5.355-5.524c-4.24-1.683-11.6-1.209-11.6-1.209h-94.074s-4.211.132-5.953 2.805-1.014 7.888-1.014 7.888l14.443 64.77a15.253 15.253 0 003.556 6.473 12.793 12.793 0 006.427 2.713h109.4z"
                    fill="#fff"
                  />
                </g>
                <path
                  data-name="Path 1687"
                  d="M246.118 2459.378l16.076 74.862h22.905l-16.3-74.862z"
                  fill="#ededff"
                />
                <path
                  data-name="Path 1688"
                  d="M276.268 2460.351h26.005l1.4 4.088h-26.23z"
                  fill="#575757"
                  opacity={0.138}
                />
                <path
                  data-name="Path 1689"
                  d="M330.297 2460.351h26.005l1.4 4.088h-26.23z"
                  fill="#575757"
                  opacity={0.138}
                />
                <path
                  data-name="Path 1690"
                  d="M278.155 2469.371h60.4l18.936 64.826h-65.772z"
                  fill="#a4a5f5"
                  opacity={0.395}
                />
                <path
                  data-name="Path 1691"
                  d="M342.387 2469.372h15.5l2.1 5.48-17.606.616-1.66-6.1z"
                  fill="#3d21e3"
                  opacity={0.209}
                />
                <path
                  data-name="Path 1692"
                  d="M345.566 2479.105h15.5l2.1 5.48-17.606.616-1.66-6.1z"
                  fill="#3d21e3"
                  opacity={0.209}
                />
                <path
                  data-name="Path 1693"
                  d="M348.744 2488.838h15.5l2.1 5.48-17.606.616-1.66-6.1z"
                  fill="#3d21e3"
                  opacity={0.209}
                />
              </g>
            </g>
          </g>
          <g data-name="Group 1248" fill="#b47a52">
            <path
              data-name="Path 26"
              d="M1387.379 649.962c-1.661-6.883-12.402-19.257-40.348-14.279s-62.191 9.827-62.191 9.827v10.096s36.737 5.172 69.026 6.105 35.181-4.883 33.513-11.749z"
            />
            <path
              data-name="Path 32"
              d="M1292.363 646.835l-21.426-5.572s-7.795 3.353-9.78 4.552c-.942.567-8.296 5.488-7.886 8.58.278 2.095 8.65-2.01 15.151-2.828 2.277-.29 3.894 2.162 5.062 2.59a40.189 40.189 0 0015.15 1.773z"
            />
          </g>
        </g>
        <g>
          <path
            data-name="Path 1698"
            d="M1184.967 51h-203a26 26 0 00-26 26v203a26 26 0 0026 26h203a26 26 0 0026-26V77a26 26 0 00-26-26z"
            fill="#fa8380"
          />
          <path
            data-name="Subtraction 6"
            d="M982.386 50.681H1185a25.979 25.979 0 0126 26v202.444a25.987 25.987 0 01-12.456 22.2L958.511 66.37a26.007 26.007 0 0123.875-15.689z"
            fill="#fff"
            opacity={0.09}
          />
          <g
            data-name="Mask Group 457"
            transform="translate(954.967 51)"
            clipPath="url(#prefix__g)">
            <g data-name="Group 1247">
              <g
                data-name="Mask Group 454"
                transform="translate(-60.047)"
                clipPath="url(#prefix__k)">
                <g data-name="Group 1195">
                  <g data-name="Group 1194">
                    <g data-name="Group 857">
                      <g data-name="Group 855">
                        <g
                          data-name="Mask Group 400"
                          clipPath="url(#prefix__l)"
                          transform="translate(13.01 -.4)">
                          <g data-name="Group 881">
                            <g data-name="Group 880">
                              <path
                                data-name="Path 975"
                                d="M128.408 311.027l-19.572-121.352s-6.744-18.244 6.737-27.363l51.379-24.514H203.2l56.393 36.287-35.11 136.948z"
                                fill="#ffcca0"
                              />
                              <path
                                data-name="Path 988"
                                d="M203.381 110.997v39.31h-40.959s10.07-15.583 5.035-39.311z"
                                fill="#ffcca0"
                              />
                              <path
                                data-name="Path 989"
                                d="M180.582 134.329c-8.568 2.406-11.472-7.923-11.472-7.923s.814-6.16-2.639-15.408h36.912v5.783c-4.848 7.785-14.233 15.142-22.8 17.548z"
                                fill="#e9b287"
                              />
                              <path
                                data-name="primary"
                                d="M231.137 307.732c-.086 4.042 5.957 46.34 3.423 46.884-.017 0-69.14 16.171-106.005 0l-.146-43.585-23.678-56.207s-4.686-80.367 4.757-89.971l57.465-27.045-3.466 10.58s3.286 19.108 13.211 16.465 26.488-27.036 26.488-27.036l53.715 32.2c-3.449 11.61 1.169 28.067-2.271 39.681-6.369 21.4-12.566 42.871-19.127 64.215.008-.005-5.43 23.143-4.366 33.819z"
                                fill="#5d48f8"
                              />
                            </g>
                          </g>
                        </g>
                      </g>
                      <path
                        data-name="Path 966"
                        d="M215.655 69.718a60.866 60.866 0 0110.19-2.487c2.187.072 5.227 3.671 4.515 10.312s-7.296 16.245-7.296 16.245z"
                        fill="#ffcca0"
                      />
                      <path
                        data-name="Path 967"
                        d="M182.691 69.91l-8.48 18.313 10.492 3.837z"
                        fill="#ffcca0"
                      />
                      <g data-name="Group 856">
                        <path
                          data-name="Path 968"
                          d="M188.802 78.541l.701-.788a10.941 10.941 0 017.214-3.803 50.252 50.252 0 0110.544 1.959"
                          fill="none"
                          stroke="#360e0e"
                          strokeWidth={0.662}
                        />
                        <path
                          data-name="Path 969"
                          d="M196.955 73.692c-1.695-.494-4.963-.08-5.445 1.634s1.989 4.101 3.682 4.595a3.2 3.2 0 002.443-.29 3.165 3.165 0 001.507-1.93 3.247 3.247 0 00-2.188-4.011z"
                          fill="#360e0e"
                        />
                      </g>
                      <path
                        data-name="Path 970"
                        d="M185.791 65.402l.725 3.853s6.257-1.71 11.71-3.095a24.41 24.41 0 0110.543-.149 10.43 10.43 0 00-8.852-3.11c-5.745.585-14.126 2.501-14.126 2.501z"
                        fill="#6a2c14"
                      />
                      <path
                        data-name="Path 971"
                        d="M179.558 100.68a13.385 13.385 0 001.7.06c1.455.02 3.174.11 3.174.11l7.264 1s-6.725 4.184-10.632 4.471-8.067-4.32-8.067-4.32a19.732 19.732 0 016.561-1.321z"
                        fill="#e3a275"
                      />
                      <path
                        data-name="Path 972"
                        d="M177.609 76.831s-4.586-3.578-7.561-2.988a21.207 21.207 0 00-4.026 1.063"
                        fill="none"
                        stroke="#360e0e"
                        strokeWidth={0.662}
                      />
                      <path
                        data-name="Path 973"
                        d="M171.263 73.353c-1.4.024-3.429.491-3.402 2.042a4.373 4.373 0 003.498 3.557 2.678 2.678 0 002.496-2.834 2.716 2.716 0 00-.733-1.921 2.636 2.636 0 00-1.859-.844z"
                        fill="#360e0e"
                      />
                      <path
                        data-name="Path 974"
                        d="M176.829 65.291l-.38 3.496s-3.476-.892-6.508-1.571a8.6 8.6 0 00-5.862 1.157s1.721-4 4.918-4.134a34.092 34.092 0 017.832 1.052z"
                        fill="#6a2c14"
                      />
                    </g>
                    <path
                      data-name="Path 964"
                      d="M164.751 90.275c2.54 2.57 3.493 6.443 4.723 9.863 9.49-12.7 16.471-37.647 2.957-49.083-20.308-17.181-20.714 26.049-7.68 39.22z"
                      fill="#502d1f"
                    />
                    <g data-name="face">
                      <path
                        data-name="Path 4"
                        d="M232.98 82.489c7.59-23.083-6.923-45.555-15.12-49.554s-26.206-10.181-39.601-1.498-23.107 18.742-18.72 42.286 19.111 53.054 35.973 52.552 29.877-20.692 37.468-43.786z"
                        fill="#ffcca0"
                      />
                      <path
                        data-name="Intersection 1"
                        d="M188.97 125.097c-5.14-2.202-10.562-7.257-15.149-14.457a113.261 113.261 0 01-14.278-36.879c-4.398-23.539 5.32-33.59 18.714-42.271a25.945 25.945 0 015.542-2.708z"
                        fill="#e9b287"
                      />
                      <path
                        data-name="Path 6"
                        d="M186.589 79.166l-4.311 19.43 11.118.705z"
                        fill="#ffcca0"
                      />
                      <path
                        data-name="Path 7"
                        d="M198.176 82.588l.644-.834a10.915 10.915 0 016.927-4.288 50.314 50.314 0 0110.657 1.227"
                        fill="none"
                        stroke="#360e0e"
                      />
                      <path
                        data-name="Path 8"
                        d="M182.407 83.394s-5.213-4.742-8.981-4.544c-3.173.376-4.517 1.308-7.51 2.423"
                        fill="none"
                        stroke="#360e0e"
                      />
                      <path
                        data-name="Path 9"
                        d="M205.845 78.14a3.121 3.121 0 00-4.074.91 2.7 2.7 0 00-.367 2.026 2.437 2.437 0 001.174 1.604 2.612 2.612 0 002.01.448 2.788 2.788 0 001.772-1.143 2.762 2.762 0 00-.513-3.847zM174.846 79.139a3.121 3.121 0 00-4.074.911 2.7 2.7 0 00-.367 2.026 2.437 2.437 0 001.173 1.603 2.612 2.612 0 002.01.449 2.788 2.788 0 001.773-1.143 2.762 2.762 0 00-.514-3.848z"
                        fill="#360e0e"
                      />
                      <path
                        data-name="Path 12"
                        d="M183.151 70.203l-.48 3.5s-5.737-.887-10.727-1.554a21.11 21.11 0 00-9.557 1.173 10.243 10.243 0 017.888-4.154 90.42 90.42 0 0112.876 1.028z"
                        fill="#502d1f"
                      />
                      <path
                        data-name="Path 34"
                        d="M194.358 69.42l.996 3.791s6.127-2.136 11.47-3.895a24.426 24.426 0 0110.514-.88 10.457 10.457 0 00-9.058-2.493c-5.695.981-13.922 3.477-13.922 3.477z"
                        fill="#502d1f"
                      />
                      <path
                        data-name="Path 13"
                        d="M188.618 106.915a18.7 18.7 0 002.008-.105c1.715-.12 3.75-.197 3.75-.197l8.701-1.55s-7.572 6.665-12.152 7.326-9.987-4.39-9.987-4.39a44.471 44.471 0 017.68-1.085z"
                        fill="#d6905f"
                      />
                    </g>
                    <path
                      data-name="Path 1001"
                      d="M205.598 45.633s17.14 17.14 21.109 28.813-.935 25.97-.937 25.976c.062-.435 1.847-1.598 2.202-1.933a70.9 70.9 0 007.575-11.425c7.106-13.345 3.828-15.053 5.517-22.802 1.155-5.29-4.345-26.899-13.097-33.577 0 0-19.632.086-22.37 14.948z"
                      fill="#502d1f"
                    />
                    <path
                      data-name="Path 975"
                      d="M224.698 73.64a11.482 11.482 0 015.13-1.937c1.937.162 4.458 3.411 3.532 9.122s-7.231 13.72-7.231 13.72z"
                      fill="#ffcca0"
                    />
                  </g>
                </g>
              </g>
              <path
                data-name="Path 61746"
                d="M157.56 50.406s-25.833 4.082-38.363 4.068c-11.83-.012-19.505.683-27.613-8.284s-7.179-23.95-7.179-23.95a66.035 66.035 0 0023.79 4.849c13.622.235 49.366 23.317 49.366 23.317z"
                fill="#502d1f"
              />
              <path
                data-name="Path 61748"
                d="M100.39 48.815l3.672 2.008a25.462 25.462 0 00-3.672 8.654 108.746 108.746 0 00-2.137 14.394l-1.132-14.394z"
                fill="#502d1f"
              />
            </g>
          </g>
          <g data-name="Group 1246">
            <path
              data-name="Rectangle 1140"
              d="M1080.61 257.48l-18.046 3.484a3.971 3.971 0 00-3.16 4.653l7.93 40.524a4 4 0 004.685 3.138l18.045-3.482a3.971 3.971 0 003.16-4.653l-7.93-40.525a4 4 0 00-4.685-3.14z"
              fill="#e0e0e0"
            />
            <path
              data-name="Rectangle 1141"
              d="M1081.731 258.908l-6.276 1.212a1.588 1.588 0 00-1.268 1.862l1.224 6.232a1.6 1.6 0 001.874 1.255l6.272-1.209a1.588 1.588 0 001.268-1.862l-1.22-6.235a1.6 1.6 0 00-1.874-1.255z"
              fill="#fff"
              opacity={0.211}
            />
            <g data-name="Ellipse 28" fill="#2b2b2b">
              <path d="M1081.14 259.982h.001a1.465 1.465 0 011.716 1.149 1.454 1.454 0 01-1.156 1.703 1.465 1.465 0 01-1.717-1.149 1.454 1.454 0 011.155-1.703z" />
              <path
                d="M1081.165 260.114a1.32 1.32 0 00-1.049 1.545 1.33 1.33 0 001.56 1.043 1.32 1.32 0 001.05-1.545 1.33 1.33 0 00-1.56-1.043h-.001m-.052-.264h.003a1.598 1.598 0 011.874 1.255 1.588 1.588 0 01-1.264 1.862 1.598 1.598 0 01-1.875-1.256 1.588 1.588 0 011.262-1.861z"
                fill="#262626"
              />
            </g>
            <g data-name="Ellipse 29" fill="#2b2b2b">
              <path d="M1081.97 263.866h.002a1.465 1.465 0 011.717 1.149 1.454 1.454 0 01-1.156 1.703 1.465 1.465 0 01-1.718-1.15 1.454 1.454 0 011.155-1.703z" />
              <path
                d="M1081.996 263.998a1.32 1.32 0 00-1.049 1.545 1.33 1.33 0 001.56 1.042 1.32 1.32 0 001.05-1.545 1.33 1.33 0 00-1.559-1.042h-.002m-.051-.265h.002a1.598 1.598 0 011.874 1.256 1.588 1.588 0 01-1.264 1.861 1.598 1.598 0 01-1.874-1.255 1.588 1.588 0 011.262-1.862z"
                fill="#262626"
              />
            </g>
            <g data-name="Ellipse 30" fill="#2b2b2b">
              <path d="M1076.448 260.973h.002a1.465 1.465 0 011.716 1.15 1.454 1.454 0 01-1.156 1.703 1.465 1.465 0 01-1.717-1.15 1.454 1.454 0 011.155-1.703z" />
              <path
                d="M1076.474 261.106a1.32 1.32 0 00-1.05 1.544 1.33 1.33 0 001.561 1.043 1.32 1.32 0 001.049-1.545 1.33 1.33 0 00-1.558-1.043h-.002m-.052-.264h.002a1.598 1.598 0 011.875 1.255 1.588 1.588 0 01-1.265 1.862 1.598 1.598 0 01-1.874-1.256 1.588 1.588 0 011.262-1.861z"
                fill="#262626"
              />
            </g>
          </g>
          <g data-name="Group 861" fill="#ffcca0">
            <path
              data-name="Path 986"
              d="M1166.135 364.539l-36.822-108.43c-1.807-27.59 19.183-33.553 19.183-33.553 19.869-4.17 26.187 17.254 26.187 17.254l19.474 110.056s5.485 24.644-5.896 25.994c-.006 0-18.93 4.285-22.126-11.321z"
            />
            <path
              data-name="Path 987"
              d="M1193.81 353.659s-25.653-19.056-49.673-32.69a349.63 349.63 0 00-46.41-21.85l-6.21 9.831s61.16 62.713 88.523 74.205c-.002 0 23.513-9.565 13.77-29.496z"
            />
          </g>
          <path
            data-name="Path 1694"
            d="M1095.356 293.392v-10.35l-7.821-8.242 1.4 8.245-29.48-6.785v14.062l18.7 14.211 15.26 5.2 5.446-9.143z"
            fill="#ffcca0"
          />
          <path
            data-name="primary"
            d="M1136.976 204.553s25.586 9.39 33.629 21.36 12.057 53.119 12.057 53.119l-35.983 32.41-33.683-69.99z"
            fill="#5d48f8"
          />
          <path
            data-name="Path 61745"
            d="M1125.478 82.24l5.94 13.306s-34.389 2.239-47.916-2.894-24.422-20.764-24.422-20.764a55.329 55.329 0 0020.655 3.028c11.778-.494 16.14-4.209 26.623-3.038s19.12 10.362 19.12 10.362z"
            fill="#502d1f"
          />
        </g>
      </g>
    </svg>
  );
};

export default InviteFriends;
